import {
  type ContactPersonCollection,
  contactPersonCollectionSchema,
  type ContactPerson,
  contactPersonSchema, contactPersonFilterSchema, type ContactPersonFilter,
} from '@/types/Wiser/contactPerson.ts'

import { createRestApi, type HttpClient, type ModelApi } from '@jantm/model-core'

export type ContactPersonApi = ModelApi<ContactPerson, ContactPersonCollection, ContactPersonFilter>

/**
 * The HTTP client is injected rather than imported so this package never pins
 * an axios instance, a base URL, or an auth interceptor — the host application
 * owns all three.
 */
export function createContactPersonApi(
  client: HttpClient,
  endpoint = '/wiser/contactpersoon',
): ContactPersonApi {
  return createRestApi({
    client,
    endpoint,
    schema: contactPersonSchema,
    collectionSchema: contactPersonCollectionSchema,
    filterSchema: contactPersonFilterSchema,
  })
}
